export default {"src":"/_next/static/media/gradient_account.9eb7299a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};